var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorPlanCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8582_110300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#0089EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5625,
    y: 12.5625,
    width: 28.875,
    height: 28.875,
    rx: 14.4375,
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5625,
    y: 12.5625,
    width: 28.875,
    height: 28.875,
    rx: 14.4375,
    stroke: "#E3F2FD",
    strokeWidth: 0.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6267 21.8408V21.1926C30.7396 21.1943 31.8065 21.6363 32.5947 22.422C33.3828 23.2077 33.828 24.2733 33.8332 25.3861H33.185C33.185 24.9195 33.0929 24.4574 32.9139 24.0264C32.7349 23.5954 32.4726 23.204 32.142 22.8746C31.8114 22.5452 31.4191 22.2843 30.9874 22.1069C30.5558 21.9295 30.0934 21.8391 29.6267 21.8408ZM31.8822 25.3861H32.5304C32.527 24.6136 32.2186 23.8738 31.6724 23.3275C31.1261 22.7813 30.3862 22.4729 29.6137 22.4695V23.1176C30.2154 23.1176 30.7924 23.3566 31.2178 23.7821C31.6432 24.2075 31.8822 24.7845 31.8822 25.3861ZM30.5859 25.3861H31.2341C31.2341 24.9564 31.0634 24.5442 30.7595 24.2404C30.4556 23.9365 30.0435 23.7658 29.6137 23.7658V24.4139C29.7419 24.4122 29.8691 24.4361 29.9878 24.4844C30.1066 24.5326 30.2144 24.6042 30.3051 24.6948C30.3957 24.7854 30.4673 24.8933 30.5155 25.012C30.5637 25.1308 30.5877 25.258 30.5859 25.3861ZM32.0702 29.651L33.198 30.7787L31.1628 32.8074L30.0739 31.6602L29.1017 32.626L26.2304 29.813L25.2063 30.8306H23.5535C23.4633 31.1283 23.2798 31.3891 23.03 31.5747C22.7803 31.7602 22.4776 31.8606 22.1665 31.8611V31.1158C22.2697 31.1357 22.376 31.1326 22.4779 31.1067C22.5797 31.0807 22.6746 31.0326 22.7556 30.9657C22.8367 30.8988 22.902 30.8148 22.9468 30.7197C22.9916 30.6247 23.0148 30.5209 23.0148 30.4158C23.0148 30.3107 22.9916 30.2069 22.9468 30.1118C22.902 30.0167 22.8367 29.9328 22.7556 29.8659C22.6746 29.799 22.5797 29.7508 22.4779 29.7249C22.376 29.6989 22.2697 29.6958 22.1665 29.7158V28.951C22.4973 28.9512 22.8184 29.0635 23.0773 29.2694C23.3362 29.4754 23.5178 29.7629 23.5924 30.0852H24.8887L25.6859 29.2815L22.2961 25.8723V23.5324L25.8609 22.1843L32.6989 29.0287L32.0702 29.651ZM31.5452 29.126L31.6424 29.0287L25.6665 23.0528L23.035 24.0445V25.5611L29.0693 31.5954L29.51 31.1547L31.5452 29.126ZM31.5452 30.1824L30.5665 31.1547L31.1628 31.751L32.1415 30.7787L31.5452 30.1824Z",
    fill: "#006FC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8582_110300",
    x: -1,
    y: -1,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8582_110300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8582_110300",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorPlanCameraIcon);
export default __webpack_public_path__ + "static/media/floorPlanCameraIcon.05a18b9e66aee8283b38176ac88a35e1.svg";
export { ForwardRef as ReactComponent };